import {useLocation, useNavigate} from 'react-router-dom';
import OTP from '../../common/components/otp/OTP';
import {useAuthedMutation} from '../../../../common/hooks/QueryHooks';
import {OTPValidated} from '../../common/components/otp/Types';
import {routes} from '../../../../routing/routes';
import {useAuth} from '../../providers/AuthProvider';

export default function VerifyProfile() {
	const navigate = useNavigate();
	const location = useLocation();
	const {currentUser, logout} = useAuth();
	const {mutate} = useAuthedMutation<OTPValidated>('/enterpriser/profile/verify-email');

	if (!currentUser) return null;

	const goBack = () => {
		logout();

		const backRoute = currentUser.enterpriser === undefined ? routes.register : routes.login;
		navigate(backRoute);
	};

	if (location.state === null && currentUser.enterpriser === undefined) {
		console.error('Error: `location.state` or `currentUser.enterpriser` must be set to access this page');
		goBack();
		return null;
	}

	const email = (location.state ? location.state.email : currentUser.enterpriser?.email) as string;

	const validate = async (code: string) => {
		const data = {email, code};
		await mutate({data});

		const redirectRoute = currentUser.enterpriser?.profileCompleted ? routes.dashboard : routes.completeProfile;
		navigate(redirectRoute);
	};

	return <OTP email={email} onValidate={validate} onBack={goBack} />;
}
